



















































































































import Vue from "vue";
import store from "@/store";
import moment from "moment";
import draggable from "vuedraggable";

// Components
import ExerciseCard from "@/components/ExerciseCard.vue";

// Dialogs
import DoneWorkingOutDialog from "@/components/dialogs/DoneWorkingOutDialog.vue";
import AddNewExerciseDialog from "@/components/dialogs/AddNewExerciseDialog.vue";

// Interfaces
import {
  Exercise,
  ExerciseEmitData,
  SetEmitData,
} from "@/interfaces/exercise.interface";
import { dialogOptions } from "@/interfaces/dialog.interface";
import { AllTypesOfSets, WeightSet } from "@/interfaces/sets.interface";
import { getNowInUnix, secondsToTime } from "@/interfaces/time.interface";
import { ExerciseTemplate } from "@/interfaces/workoutTemplate.interface";
import { Workout, SubmitWorkoutData } from "@/interfaces/workout.interface";
import { removeExerciseClientHelpers } from "@/interfaces/exercise.interface";
export default Vue.extend({
  data: () => {
    return {
      // Dialogs
      addNewExerciseDialog: false,
      createExerciseDialog: false,
      doneWorkingOutDialog: false,

      // Workout Data
      workoutName: "Workout",
      workoutNote: "",
      lastTimeSetCompleted: -1,

      // Time Tracker
      startTime: getNowInUnix(),
      nowTime: moment().unix(),
      timeWorkingOut: "0:00",
      timeInterval: 0,

      storeTimer: 0,

      errorSnackBar: false,
      errorSnackBarText: "There was a problem on our side, try again.",

      // Exercise Data
      exercises: [] as Exercise[],

      totalVideoSize: 0,

      overlay: false,

      showTimeToolTip: false,
      timeSinceLastSet: "0:00",

      doneWorkingOutData: Object() as Workout,
    };
  },
  created() {
    this.resetWorkoutData();
    this.storeTimer = setInterval(async () => {
      console.log("Sending Updated Workout To Store");
      const currentWorkoutData: Workout = {
        workoutName: this.workoutName,
        workoutNote: this.workoutNote,
        startTime: this.startTime,
        exercises: this.exercises,
        lastSetCompleted: this.lastTimeSetCompleted,
      };
      store.commit("workoutStore/setCurrentWorkout", currentWorkoutData);
    }, 60000);
  },
  methods: {
    // Dialog Methods =============================
    parentDialogController(dialogToBeOpen: dialogOptions) {
      this.collapseCurrentWorkoutDialog();
      if (dialogToBeOpen === "closeAll") {
        const currentWorkoutData: Workout = {
          workoutName: this.workoutName,
          startTime: getNowInUnix(),
          exercises: this.exercises,
        };
        store.commit("workoutStore/setCurrentWorkout", currentWorkoutData);
      }

      this.$emit("dialogController", dialogToBeOpen);
    },
    localDialogController(dialogToBeOpen: dialogOptions) {
      this.addNewExerciseDialog = false;
      this.createExerciseDialog = false;

      if (dialogToBeOpen === "addNewExerciseDialog")
        this.addNewExerciseDialog = true;
      if (dialogToBeOpen === "createExerciseDialog")
        this.createExerciseDialog = true;
    },
    collapseCurrentWorkoutDialog() {
      store.commit("workoutStore/changeCurrentWorkoutDialogCollapse", false);
    },
    closeCurrentWorkout(): void {
      store.commit("workoutStore/clearCurrentWorkout");
      this.resetWorkoutData();
      this.collapseCurrentWorkoutDialog();
    },
    // Total Workout Data ========================
    async submitWorkout() {
      let initialExerciseData: Exercise[] = this.exercises;

      if (initialExerciseData.length === 0) {
        alert("Complete at least one exercise with one set.");
      } else if (this.totalVideoSize > 100000000) {
        alert("Total Video Size Is Over 100 MB");
      } else {
        this.overlay = true;
        let submitData: SubmitWorkoutData = {
          workoutData: {
            workoutName: this.workoutName,
            startTime: this.startTime,
            endTime: getNowInUnix(),
            exercises: [],
          },
          formatedExercies: removeExerciseClientHelpers(initialExerciseData),
        };

        const currentWorkout: Workout | null =
          store.getters["workoutStore/getCurrentWorkout"];

        if (currentWorkout?.templateId)
          submitData.templateId = currentWorkout.templateId;

        await store
          .dispatch("workoutStore/submitWorkout", submitData)
          .then((resolvedWorkoutData: Workout) => {
            this.overlay = false;

            store.commit(
              "historyStore/addWorkoutToHistory",
              resolvedWorkoutData
            );

            this.resetWorkoutData();

            this.doneWorkingOutData = resolvedWorkoutData;
            this.doneWorkingOutDialog = true;
          })
          .catch(() => {
            alert("There was a problem uploading your workout :(");
            this.overlay = false;
          });

        await store
          .dispatch("workoutStore/updateCurrentWorkout", null)
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    resetWorkoutData(): void {
      this.workoutName = "";
      this.workoutNote = "";
      this.exercises = [];
      this.lastTimeSetCompleted = -1;
      this.doneWorkingOutData = Object() as Workout;
      clearInterval(this.timeInterval);

      const workoutFromStore: Workout | null =
        store.getters["workoutStore/getCurrentWorkout"];

      if (workoutFromStore) {
        this.workoutName = workoutFromStore.workoutName;
        this.startTime = workoutFromStore.startTime;
        this.lastTimeSetCompleted = workoutFromStore.lastSetCompleted
          ? workoutFromStore.lastSetCompleted
          : -1;

        // makes exercise.sets reactive
        workoutFromStore.exercises.forEach((exercise) => {
          let setListWithReactiveData: any = [];

          exercise.sets.forEach((set) => {
            let setReactiveData = Object.assign({}, set);
            setReactiveData.done = set.done ? true : false;
            setReactiveData.wantVideo = false;
            if (!setReactiveData.setNoteWanted)
              setReactiveData.setNoteWanted = false;
            setListWithReactiveData.push(setReactiveData);
          });

          const formattedExercise: Exercise = {
            exerciseName: exercise.exerciseName,
            bodyParts: exercise.bodyParts,
            type: exercise.type,
            sets: setListWithReactiveData,
            showExercise: true,
            wantExerciseNote: false,
          };

          this.exercises.push(formattedExercise);
        });

        if (workoutFromStore.workoutNote)
          this.workoutName = workoutFromStore.workoutNote;

        this.timeInterval = setInterval(() => {
          this.timeWorkingOut = secondsToTime(
            moment().unix() - this.startTime,
            false,
            true
          );
          if (this.lastTimeSetCompleted === -1)
            this.timeSinceLastSet = "Not Done";
          else {
            this.timeSinceLastSet = secondsToTime(
              moment().unix() - this.lastTimeSetCompleted,
              false,
              true
            );
            if (this.timeSinceLastSet === "2:00" && navigator)
              navigator.vibrate(500);
          }
        }, 1000);
      }
    },
    //  Todo: need to give alert that it did not work if it didint
    async cancelWorkout() {
      this.overlay = true;
      await store
        .dispatch("workoutStore/updateCurrentWorkout", null)
        .then((res) => {
          console.log(res);
          this.overlay = false;
        })
        .catch((err) => {
          console.error(err);
          this.overlay = false;
        });
      this.resetWorkoutData();
      store.commit("workoutStore/clearCurrentWorkout");
      store.commit("workoutStore/changeCurrentWorkoutDialogCollapse", false);
    },

    // Adding Exercises
    addExercises(newExercises: Exercise[]): void {
      newExercises.forEach((newExercise) => {
        console.log(newExercise);
        console.log(this.exercises);

        this.exercises.push(newExercise);
      });
      this.localDialogController("currentWorkoutDialog");
    },
    addExerciseFromTemplate(basicExerciseData: ExerciseTemplate): void {
      let formattedSets: any = [];
      basicExerciseData.sets.forEach((set) => {
        let formattedSet: AllTypesOfSets = set;
        formattedSet.done = false;
        formattedSets.push(formattedSet);
      });

      let formattedExercise: Exercise = {
        exerciseName: basicExerciseData.exerciseName,
        bodyParts: basicExerciseData.bodyParts,
        type: basicExerciseData.type,
        sets: formattedSets,
        showExercise: true,
      };
      this.exercises.push(formattedExercise);
    },
    // Exercise Cards Methods =======
    changeSetValue(setEmitData: SetEmitData) {
      // Todo: Add "Set Note"
      if (setEmitData.setChangeType === "Add Set") {
        let exercise: Exercise = this.exercises[setEmitData.exerciseIdx];
        let duplicateLastSetData = Object.assign(
          {},
          exercise.sets[exercise.sets.length - 1]
        );
        duplicateLastSetData.done = false;
        exercise.sets.push(duplicateLastSetData);
        this.exercises[setEmitData.exerciseIdx] = exercise;
      }

      if (setEmitData.setChangeType === "Remove Set") {
        this.exercises[setEmitData.exerciseIdx].sets.splice(
          setEmitData.setIdx,
          1
        );
      }

      if (setEmitData.setChangeType === "Set Completion") {
        this.exercises[setEmitData.exerciseIdx].sets[
          setEmitData.setIdx
        ].done = !this.exercises[setEmitData.exerciseIdx].sets[
          setEmitData.setIdx
        ].done;
        this.lastTimeSetCompleted = moment().unix();
      }

      if (
        setEmitData.setChangeType === "Replace Set Values" &&
        setEmitData.newValues
      ) {
        let duplicatedSetData = this.exercises[setEmitData.exerciseIdx].sets[
          setEmitData.setIdx
        ];

        duplicatedSetData.weight = Number(setEmitData.newValues.weight);
        duplicatedSetData.reps = Number(setEmitData.newValues.reps);

        this.exercises[setEmitData.exerciseIdx].sets[
          setEmitData.setIdx
        ] = duplicatedSetData;
      }
    },
    removeExercise(exerciseIdx: number) {
      this.exercises.splice(exerciseIdx, 1);
    },
    changeSetVideo(exerciseEmitData: ExerciseEmitData) {
      let exerciseSet = Object.assign(
        {},
        this.exercises[exerciseEmitData.exerciseIdx].sets[
          exerciseEmitData.setIdx
        ]
      );

      if (exerciseEmitData.video) {
        exerciseSet.videoBlob = exerciseEmitData.video;
        if (exerciseEmitData.video)
          this.totalVideoSize += exerciseEmitData.video?.size;
      } else {
        if (exerciseSet.videoBlob)
          this.totalVideoSize -= exerciseSet.videoBlob.size;
        delete exerciseSet.videoBlob;
      }

      this.exercises[exerciseEmitData.exerciseIdx].sets[
        exerciseEmitData.setIdx
      ] = exerciseSet;
    },
    changeSetNote(exerciseEmitData: ExerciseEmitData) {
      if (exerciseEmitData.addNote) {
        this.exercises[exerciseEmitData.exerciseIdx].sets[
          exerciseEmitData.setIdx
        ].setNote = "";
        this.exercises[exerciseEmitData.exerciseIdx].sets[
          exerciseEmitData.setIdx
        ].setNoteWanted = true;
      } else {
        delete this.exercises[exerciseEmitData.exerciseIdx].sets[
          exerciseEmitData.setIdx
        ].setNote;
        this.exercises[exerciseEmitData.exerciseIdx].sets[
          exerciseEmitData.setIdx
        ].setNoteWanted = false;
      }
    },
    getPreviousExerciseSets(exercise: Exercise): WeightSet[] {
      let previousSets: WeightSet[] = [];
      const currentWorkout: Workout | null =
        store.getters["workoutStore/getCurrentWorkout"];
      // Todo: check if you have gotten workout history yet, if not get workouts,

      const previousWorkouts: Workout[] =
        store.getters["historyStore/getWorkoutHistory"];

      if (currentWorkout?.templateId) {
        previousWorkouts.forEach((workout) => {
          if (workout.templateId === currentWorkout.templateId) {
            workout.exercises.forEach((preExercise) => {
              if (preExercise.exerciseName === exercise.exerciseName)
                previousSets = preExercise.sets;
            });
          }
        });
      } else {
        previousWorkouts.forEach((workout) => {
          workout.exercises.forEach((preExercise) => {
            if (preExercise.exerciseName === exercise.exerciseName)
              previousSets = preExercise.sets;
          });
        });
      }

      return previousSets;
    },
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
    clearInterval(this.storeTimer);
  },
  computed: {
    currentWorkoutDialog(): boolean {
      return store.getters["workoutStore/isCurrentWorkoutDialogCollapsed"];
    },
    currentWorkoutData(): Workout {
      return store.getters["workoutStore/getCurrentWorkout"] as Workout;
    },
  },
  components: {
    AddNewExerciseDialog,
    ExerciseCard,
    draggable,
    DoneWorkingOutDialog,
  },
});
